import { render } from "./monthGoods.vue?vue&type=template&id=0c4fafcb&scoped=true"
import script from "./monthGoods.vue?vue&type=script&lang=js"
export * from "./monthGoods.vue?vue&type=script&lang=js"

import "./monthGoods.vue?vue&type=style&index=0&id=0c4fafcb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0c4fafcb"

export default script